import React from "react";
import PropTypes from "prop-types";

import { makeStyles, useTheme } from "@material-ui/styles";
import {
    fade,
    AppBar,
    Box,
    Card,
    CardContent,
    Divider,
    List,
    ListItem,
    ListItemText,
    Tab,
    Tabs,
} from "@material-ui/core";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: "100%",
    },
    tabTitle: {
        textTransform: "none",
        fontWeight: 500,
        lineHeight: 1.4,
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.5rem",
        },
    },
    tabImg: {
        maxWidth: 72,
        [theme.breakpoints.down("sm")]: {
            maxWidth: 48,
        },
    },
    tabRoot: {
        alignItems: "baseline",
    },
    tabPanelText: {
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.875rem",
        },
    },
    title: {
        display: "flex",
        alignItems: "center",
    },
    titleIcon: {
        margin: theme.spacing(0, 2, 0, 2),
    },
    listItemAvatarAvatar: {
        backgroundColor: fade(theme.palette.primary.light, 0.125),
        color: theme.palette.primary.main,
    },
    bigTitle: {
        margin: theme.spacing(10, 4, 4, 4),
        textAlign: "center",
        justifyContent: "center",
    },
    listRoot: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
    },
    listItem: {
        width: "100%",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
        alignItems: "flex-start",
        flexWrap: "wrap",
        boxShadow: theme.shadows[0],
        margin: "0 1%",
    },
    listItemLI: {
        alignItems: "flex-start",
        [theme.breakpoints.down("sm")]: {
            padding: 0,
            fontSize: "0.875rem",
        },
        "& span": {
            [theme.breakpoints.down("sm")]: {
                fontSize: "0.75rem",
            },
        },
        "& p": {
            [theme.breakpoints.down("sm")]: {
                fontSize: "0.75rem",
            },
        },
    },
    listItemTextPrimary: {
        fontWeight: theme.typography.fontWeightBold,
    },
    card: {
        margin: theme.spacing(1, 5, 5, 5),
        [theme.breakpoints.down("sm")]: {
            margin: theme.spacing(0),
        },
    },
    cardHeader: {
        backgroundColor: fade(theme.palette.primary.light, 0.125),
    },
    cardHeaderTitle: {},
    cardContent: {
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.75rem",
        },
    },
    tabIndicator: {
        maxWidth: "17%",
        minWidth: "17%",
        marginLeft: "4%",
        "& span": {
            width: 0,
            height: 0,
            borderLeft: "6px solid transparent",
            borderRight: "6px solid transparent",
            borderTop: `6px solid ${theme.palette.primary.main}`,
            position: "absolute",
            top: 1,
            left: "50%",
            transform: "translateX(-50%)",
        },
    },
    overflowVisible: {
        overflow: "visible!important",
    },
}));

const TabsAbout = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <AppBar position="static" color="transparent" elevation={0}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="tabs About"
                    classes={{
                        indicator: classes.tabIndicator,
                        root: classes.overflowVisible,
                        fixed: classes.overflowVisible,
                    }}
                    TabIndicatorProps={{ id: "s-l-i", dangerouslySetInnerHTML: { __html: "<span/>" } }}
                >
                    {abouts.map((faq, i) => {
                        return (
                            <Tab
                                key={i}
                                label={
                                    <React.Fragment>
                                        <img className={classes.tabImg} src={faq.icon} alt={faq.title} />
                                        <div
                                            className={classes.tabTitle}
                                            dangerouslySetInnerHTML={{ __html: faq.title }}
                                        />
                                    </React.Fragment>
                                }
                                classes={{ root: classes.tabRoot }}
                                {...a11yProps(i)}
                            />
                        );
                    })}
                </Tabs>
            </AppBar>

            <TabPanel value={value} index={0} dir={theme.direction}>
                <Card variant="elevation" className={classes.card} elevation={0}>
                    <List className={classes.listRoot} dense={true}>
                        {descriptions.map((description, i) => {
                            return (
                                <div className={classes.listItem} key={i}>
                                    <ListItem dense={true} className={classes.listItemLI}>
                                        <ListItemText
                                            primary={description.title}
                                            secondary={
                                                <code style={{ fontFamily: "Fira Sans, sans-serif" }}>
                                                    {description.text}
                                                </code>
                                            }
                                            classes={{ primary: classes.listItemTextPrimary }}
                                        />
                                    </ListItem>
                                    <Divider variant="inset" component="li" style={{ flex: 1 }} />
                                </div>
                            );
                        })}
                    </List>
                </Card>
            </TabPanel>

            <TabPanel value={value} index={1} dir={theme.direction}>
                <Card variant="elevation" className={classes.card} elevation={0}>
                    <List className={classes.listRoot} dense={true}>
                        {objects.map((object, i) => {
                            return (
                                <div className={classes.listItem} key={i}>
                                    <ListItem dense={true} className={classes.listItemLI}>
                                        <ListItemText
                                            primary={object.title}
                                            secondary={
                                                <code style={{ fontFamily: "Fira Sans, sans-serif" }}>
                                                    {object.text}
                                                </code>
                                            }
                                            classes={{ primary: classes.listItemTextPrimary }}
                                        />
                                    </ListItem>
                                    <Divider variant="inset" component="li" style={{ flex: 1 }} />
                                </div>
                            );
                        })}
                    </List>
                </Card>
            </TabPanel>

            <TabPanel value={value} index={2} dir={theme.direction}>
                <Card variant="elevation" className={classes.card} elevation={0}>
                    <List className={classes.listRoot} dense={true}>
                        {features.map((feature, i) => {
                            return (
                                <div className={classes.listItem} key={i}>
                                    <ListItem dense={true} className={classes.listItemLI}>
                                        <ListItemText
                                            primary={feature.title}
                                            secondary={
                                                <code style={{ fontFamily: "Fira Sans, sans-serif" }}>
                                                    {feature.text}
                                                </code>
                                            }
                                            classes={{ primary: classes.listItemTextPrimary }}
                                        />
                                    </ListItem>
                                    <Divider variant="inset" component="li" style={{ flex: 1 }} />
                                </div>
                            );
                        })}
                    </List>
                </Card>
            </TabPanel>

            <TabPanel value={value} index={3} dir={theme.direction}>
                <Card variant="elevation" className={classes.card} elevation={0}>
                    <CardContent className={classes.cardContent}>
                        <p>
                            Ostatnia całościowa aktualizacja zasobu informacyjnego RSI rozpoczęła się w drugiej połowie
                            2021 r. poprzez aktualizację opisów rejestrów i systemów informacyjnych przez jednostki je
                            prowadzące przy wykorzystaniu aplikacji internetowej RSI.
                        </p>
                        <p>
                            Podstawę prawną pozyskiwania przez GUS metadanych o rejestrach urzędowych i systemach
                            informacyjnych administracji publicznej stanowią przepisy ustawy z dnia 29 czerwca 1995r. o
                            statystyce publicznej:{" "}
                        </p>
                        <p>
                            <b>Art. 13.</b> 1. Organy administracji publicznej, Zakład Ubezpieczeń Społecznych, Narodowy
                            Fundusz Zdrowia, Komisja Nadzoru Finansowego, a także inne państwowe lub samorządowe osoby
                            prawne, organy rejestrowe oraz inne podmioty prowadzące rejestry urzędowe lub niepubliczne
                            systemy informacyjne, przekazują lub udostępniają nieodpłatnie służbom statystyki publicznej
                            zgromadzone dane w szczegółowym zakresie, postaci i terminach, określonych w programie badań
                            statystycznych statystyki publicznej, w szczególności w postaci zbiorów danych z systemów
                            teleinformatycznych, w tym wyników pomiarów, danych monitoringu środowiska, a w przypadku
                            braku systemu teleinformatycznego - w innej utrwalonej postaci.
                        </p>
                        <p>
                            2. Organy i podmioty, o których mowa w ust. 1, przekazują dane administracyjne łącznie z
                            informacjami objaśniającymi zawartość informacyjną tych danych (metadane).
                        </p>
                        <p>
                            3. Organy i podmioty, o których mowa w ust. 1, z wyłączeniem podmiotów prowadzących
                            niepubliczne systemy informacyjne, są obowiązane do:
                        </p>
                        <p>
                            <b>
                                1) przekazywania, na wniosek Prezesa Głównego Urzędu Statystycznego, informacji o
                                zawartości informacyjnej eksploatowanych systemów informacyjnych administracji
                                publicznej oraz rejestrów urzędowych;
                            </b>
                        </p>
                        <p>
                            2) informowania Prezesa Głównego Urzędu Statystycznego o projektowanym zakresie
                            informacyjnym systemów informacyjnych administracji publicznej oraz rejestrów urzędowych na
                            etapie ich tworzenia lub modernizacji.
                        </p>
                    </CardContent>
                </Card>
            </TabPanel>
        </div>
    );
};

export default TabsAbout;

const descriptions = [
    {
        title: "Nazwa systemu",
        text: "[nazwa pełna ustalona w przepisie prawnym odnoszącym się do systemu; w przypadku braku ww. przepisu nazwa techniczna przyjęta dla systemu; skrócona nazwa, jeśli jest stosowana]",
    },
    {
        title: "Gestor systemu",
        text: "[jednostka administracji publicznej prowadząca system]",
    },
    {
        title: "Podstawa prawna",
        text: "[akty prawne stanowiące podstawę prawną funkcjonowania systemu - jeśli istnieją]",
    },
    {
        title: "Cel systemu",
        text: "[zadanie publiczne, do realizacji którego służy system]",
    },
    {
        title: "Sposób prowadzenia systemu",
        text: "[centralny, rozproszony]",
    },
    {
        title: "Zasięg systemu",
        text: "[krajowy, lokalny]",
    },
    {
        title: "Forma prowadzenia systemu",
        text: "[elektroniczna, papierowa]",
    },
    {
        title: "Źródła danych i częstotliwość aktualizacji",
        text: "[źródła wykorzystywane do zasilenia i aktualizacji systemu, np. nazwy dokumentów źródłowych (formularzy, wniosków) i częstotliwość aktualizacji]",
    },
    {
        title: "Termin i formy udostępniania danych",
        text: "[termin dostępności danych zgromadzonych w systemie, forma ich udostępniania]",
    },
    {
        title: "Stan wdrożenia systemu",
        text: "[wdrożony, niewdrożony, częściowo wdrożony]",
    },
    {
        title: "Zmiany planowane do wprowadzenia w systemie",
        text: "[planowane zmiany dotyczące zakresu gromadzonych danych, zakres oraz termin wprowadzenia zmian]",
    },
];

const objects = [
    {
        title: "Nazwa obiektu",
        text: " ",
    },
    {
        title: "Opis obiektu",
        text: "[informacje uzupełniające o obiekcie]",
    },
    {
        title: "Typ obiektu",
        text: "[osoba fizyczna, osoba fizyczna prowadząca działalność gospodarczą (przedsiębiorca) lub rolniczą, podmiot (z wyjątkiem osoby fizycznej prowadzącej działalność gospodarczą lub rolniczą), obiekt przestrzenny, inny]",
    },
    {
        title: "Opis obiektu w systemie informacyjnym",
        text: "[informacje nt. przedmiotu opisu w systemie]",
    },
    {
        title: "Standardowe identyfikatory obiektu",
        text: "[numer PESEL, numer identyfikacyjny REGON, numer identyfikacji podatkowej NIP, numer KRS, identyfikator punktu adresowego, identyfikator działki ewidencyjnej, identyfikatory jednostek podziału administracyjnego (TERYT), identyfikatory miejscowości (TERYT), identyfikatory ulic (TERYT)]",
    },
];

const features = [
    {
        title: "Cechy informacyjne opisujące obiekt",
        text: "[informacje nt. najmniejszych części znaczeniowych wprowadzonych do systemu]",
    },
    {
        title: "Nazwa cechy informacyjnej",
        text: " ",
    },

    {
        title: "Definicja cechy informacyjnej",
        text: " ",
    },
    {
        title: "Źródło definicji cechy informacyjnej",
        text: " ",
    },
    {
        title: "Klasyfikacja, słownik powiązany z cechą informacyjną",
        text: "[informacje nt. standardów klasyfikacyjnych i innych klasyfikacji, wykazów i słowników stosowanych w systemie, odnoszących się do cech informacyjnych]",
    },
];

const abouts = [
    {
        id: "1",
        title: "Zakres informacji<br/> o systemach<br/> gromadzonych w RSI",
        text: "<p>Repozytorium Standardów Informacyjnych&nbsp; jest bazą wiedzy, obejmującą metadane o systemach informacyjnych administracji publicznej.</p><p>RSI to ustrukturyzowany i zorganizowany zasób informacji. Jest to użyteczne narzędzie do gromadzenia, aktualizacji, udostępniania oraz analizy informacji o systemach informacyjnych administracji publicznej oraz do uzgadniania standardów informacyjnych.</p>",
        icon: "images/icons/RSI_www-13.png",
    },
    {
        id: "2",
        title: "Obiekty opisywane<br/> w systemie<br/> informacyjnym:",
        text: "<p>Standard informacyjny to norma wprowadzona w drodze porozumienia przez grupę jednostek administracji publicznej, stanowiąca zobowiązanie do stosowania w prowadzonych systemach informacyjnych ustalonych standardów np.: identyfikatorów, klasyfikacji.</p>",
        icon: "images/icons/RSI_www-14.png",
    },
    {
        id: "3",
        title: "Cechy informacyjne<br/> opisujące<br/> poszczególne obiekty:",
        text: "<p>Systemy informacyjne administracji publicznej, tj. systemy zbierania, gromadzenia i przetwarzania informacji przez organy administracji publicznej, Zakład Ubezpieczeń Społecznych, Narodowy Fundusz Zdrowia, Komisję Nadzoru Finansowego, organy rejestrowe, inne państwowe lub samorządowe osoby prawne oraz inne podmioty prowadzące rejestry urzędowe.</p>",
        icon: "images/icons/RSI_www-15.png",
    },
    {
        id: "4",
        title: "Aktualizacja<br/> RSI",
        text: "<p>Ostatnia całościowa aktualizacja zasobu informacyjnego RSI rozpoczęła się w drugiej połowie 2021 r. poprzez aktualizację opisów rejestrów i systemów informacyjnych przez jednostki je prowadzące przy wykorzystaniu aplikacji internetowej RSI.</p><p>Podstawę prawną pozyskiwania przez GUS metadanych o rejestrach urzędowych i systemach informacyjnych administracji publicznej stanowią przepisy ustawy z dnia 29 czerwca 1995r. o statystyce publicznej: </p><p><b>Art. 13.</b> 1. Organy administracji publicznej, Zakład Ubezpieczeń Społecznych, Narodowy Fundusz Zdrowia, Komisja Nadzoru Finansowego, a także inne państwowe lub samorządowe osoby prawne, organy rejestrowe oraz inne podmioty prowadzące rejestry urzędowe lub niepubliczne systemy informacyjne, przekazują lub udostępniają nieodpłatnie służbom statystyki publicznej zgromadzone dane w szczegółowym zakresie, postaci i terminach, określonych w programie badań statystycznych statystyki publicznej, w szczególności w postaci zbiorów danych z systemów teleinformatycznych, w tym wyników pomiarów, danych monitoringu środowiska, a w przypadku braku systemu teleinformatycznego - w innej utrwalonej postaci.</p><p>2. Organy i podmioty, o których mowa w ust. 1, przekazują dane administracyjne łącznie z informacjami objaśniającymi zawartość informacyjną tych danych (metadane).</p><p>3. Organy i podmioty, o których mowa w ust. 1, z wyłączeniem podmiotów prowadzących niepubliczne systemy informacyjne, są obowiązane do:</p><p>1)	przekazywania, na wniosek Prezesa Głównego Urzędu Statystycznego, informacji o zawartości informacyjnej eksploatowanych systemów informacyjnych administracji publicznej oraz rejestrów urzędowych;</p><p>2)informowania Prezesa Głównego Urzędu Statystycznego o projektowanym zakresie informacyjnym systemów informacyjnych administracji publicznej oraz rejestrów urzędowych na etapie ich tworzenia lub modernizacji.</p>",
        icon: "images/icons/RSI_www-16.png",
    },
];
